import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import BlogReccomendations from "../BlogReccomendations";

const API =
  "https://mean3.com/backend/api/blogs.php";

const IMAGE_BASE_URL =
  "https://mean3.com/";

const BlogDetailsCard = () => {
  const { handle } = useParams();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(
          `${API}?handle=${handle}&t=${Date.now()}`
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || "Blog not found.");
        }

        setBlog(result.blog);
      } catch (error) {
        console.error("BLOG DETAILS ERROR:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (handle) {
      fetchBlog();
    }
  }, [handle]);

  const getImageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http")) {
      return image;
    }

    return `${IMAGE_BASE_URL}${image}`;
  };

  if (loading) {
    return (
      <div className="py-20 text-center">
        <h2>Loading blog...</h2>
      </div>
    );
  }

  if (error || !blog) {
    return (
      <div className="py-20 text-center">
        <h2 className="text-2xl font-bold">
          {error || "Blog not found"}
        </h2>

        <Link
          to="/blogs"
          className="inline-block mt-5 px-5 py-3 bg-[#cd2122] text-white"
        >
          Back to Blogs
        </Link>
      </div>
    );
  }

  return (
     <>
    <Helmet>
      <title>
        {blog.meta_title || blog.title || "Blogs - Mean3 Software Solutions"}
      </title>

      <meta
        name="description"
        content={blog.meta_description || ""}
      />
    </Helmet>
    <div className="bg-[#FFFF] my-[30px] max-w-[95%] lg:max-w-[90%] md:max-w-[80%] px-[10px] h-auto m-auto">

      {blog.featured_image && (
        <div className="relative">
          <img
            className="w-full object-contain"
            src={getImageUrl(blog.featured_image)}
            alt={blog.title}
          />

          {blog.publish_date && (
            <div className="absolute px-2 py-1 text-xs text-gray-400 bg-black/50 rounded bottom-2 left-2 lg:bottom-10 lg:left-7">
              {blog.publish_date}
            </div>
          )}
        </div>
      )}

      {blog.author && (
        <p className="text-blue-600 text-center md:text-left mt-8 ml-5">
          <Link
            to={`/author/${blog.author.toLowerCase()}`}
            className="hover:underline text-xl"
          >
            Published by {blog.author}
          </Link>
        </p>
      )}

      <div className="px-2 py-2 lg:px-5 lg:py-5">

        {/* <h1 className="mb-2 text-3xl lg:mb-4 lg:text-3xl">
          {blog.meta_title || blog.title}
        </h1>

        {blog.meta_description && (
          <p className="mb-6 text-lg">
            {blog.meta_description}
          </p>
        )} */}

        <div
          className="blog-detail-content"
          dangerouslySetInnerHTML={{
            __html: blog.content,
          }}
        />

        <div className="mt-10">
          <h2 className="text-lg font-semibold text-gray-600">
            What you can read next
          </h2>

          <BlogReccomendations />
        </div>

      </div>
    </div>
  </>
  );
};

export default BlogDetailsCard;